export default __webpack_public_path__ + "static/media/logo.541d3fdc.jpg";